// src/pages/Dashboard.js

import React, { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import ConversationList from '../components/ConversationList';
import ConversationSidebar from '../components/ConversationSidebar';
import { createResizeHandler } from '../utils/chatHelpers';

export default function Dashboard() {
  // const [selectedSessionId, setSelectedSessionId] = useState(null);
  
  // Resizable divider state
  // const DEFAULT_LEFT_WIDTH = 500;
  // const MIN_LEFT_WIDTH = 350;
  // const MAX_LEFT_WIDTH = 800;
  // const [leftWidth, setLeftWidth] = useState(DEFAULT_LEFT_WIDTH);

  // const handleSelectConversation = (sessionId) => {
  //   setSelectedSessionId(sessionId);
  // };

  // const handleCloseSidebar = () => {
  //   setSelectedSessionId(null);
  // };

  // Resize handler
  // const handleSeparatorMouseDown = createResizeHandler(
  //   leftWidth,
  //   setLeftWidth,
  //   MIN_LEFT_WIDTH,
  //   MAX_LEFT_WIDTH
  // );

  return (
    <Flex h="100vh" w="100%" overflow="hidden" bg="#F8F8F8">
      {/* LEFT: Conversation List */}
      <Box
        w="100%"
        h="100%"
      >
        <ConversationList 
          // onSelectConversation={handleSelectConversation}
          // selectedSessionId={selectedSessionId}
        />
      </Box>

      {/* DIVIDER - Resizable */}
      {/* {selectedSessionId && (
        <Box
          w="4px"
          h="100%"
          bg="#DADADA"
          cursor="col-resize"
          onMouseDown={handleSeparatorMouseDown}
          _hover={{ bg: "#2196F3" }}
          transition="background 0.2s"
        />
      )} */}

      {/* RIGHT: Metadata Sidebar - NOW RESPONSIVE */}
      {/* {selectedSessionId && (
        <Box flex={1} h="100%" overflow="hidden">
          <ConversationSidebar 
            sessionId={selectedSessionId}
            onClose={handleCloseSidebar}
          />
        </Box>
      )} */}
    </Flex>
  );
}
